<template>
    <div class="comp-moment-list">
        <div class="moment-list">
            <div class="moment-container">
                <ul class="moment-ul translation-list" v-if="list.length > 0">
                    <li v-for="(moment,index) in list" class="mb-4 moment-li">
                        <div class="moment-item bk-white clearfix">
                            <div class="moment-header layout-space-between mb-4">
                                <img :src="moment.owner.thumbnailAvatarUrl"
                                     class="tycoon-avatar" alt="tycoon-avatar" width="40" height="40">
                                <div class="flex-1 pl-4">
                                    <p class="text-title text-dark-gray">{{moment.owner.storeName}}</p>
                                    <div class="text-light-gray x-small pt-1 post-time">{{(moment.createOnUtc) | formatTime }}</div>
                                </div>
                            </div>
                            <!--图片-->
                            <launch-app :type="type" :params="appParams">
                                <div class="moment-picture-one mm-1" v-if="moment.pictures.length === 1">
                                    <img class="img-link"
                                         :style="{'max-height': fullWidth + 'px'}"
                                         :src="moment.pictures[0].mediaFileUrl"
                                         :data-img="moment.pictures[0].mediaFileUrl"
                                         v-if="moment.pictures[0].mediaFileUrl">
                                </div>
                                <div class="moment-pictures clearfix" v-else>
                                    <div class="moment-pic-box clearfix"
                                         :data-img="pic.mediaFileUrl"
                                         :style="{'height': moment.pictures.length === 1 ? fullWidth + 'px': thirdFullWidth+'px','width': '33.33%'}"
                                         v-for="(pic,index) in moment.pictures">
                                        <img class="img-box" :src="pic.mediaFileUrl" v-if="pic.mediaFileUrl">
                                    </div>
                                </div>
                            </launch-app>
                            <!--视频-->
                            <launch-app :type="type" :params="appParams">
                                <div style="position: relative ;width:100%;height:0; background-color: #000; padding:0 0 56.25% 0;background-size: contain;margin-bottom: 1rem"
                                     v-if="moment.videos.length > 0">
                                    <div style="width:100%;position: absolute; background-color: #2f2f2f; height:0; padding:0 0 56.25% 0;background-size: contain;margin-bottom: 1rem"
                                         v-if="moment.videos.length > 0"
                                         :style="{ 'background': 'url(' + moment.videos[0].thumbnailUrl + ') no-repeat center center', 'backgroundSize': 'contain'}"></div>
                                    <div id="tweebaaPlayerElement"
                                         style="width:100%; position: absolute; z-index: 999; background-color: rgba(0,0,0,0); height:0; padding:0 0 56.25% 0; margin-bottom: 1rem"
                                         v-show="moment.videos.length>0"></div>
                                    <a href="javascript:;" class="play-btn"><img src="../image/video-play.png" class="img"></a>
                                </div>
                            </launch-app>
                            <!--文字内容-->
                            <div class="moment-content overflow"
                                 v-html="moment.content"></div>

                            <!--链接-->
                            <div id="linkBox"
                                 class="link-box mb-3"
                                 @click="openLink(moment.externalPostUrl)"
                                 v-if="moment.externalPostUrl">
                                <div class="link-icon"><i class="icon iconshare icon-lianjie"></i></div>
                                <div class="link-text text-title">
                                    <span v-if="moment.externalPostText">{{moment.externalPostText}}</span>
                                    <span v-if="!moment.externalPostText&&!moment.Title">{{moment.externalPostUrl}}</span>
                                    <i class="icon iconfont icon-play_fill"></i>
                                </div>
                            </div>

                            <!--产品-->
                            <launch-app :type="type" :params="appParams">
                                <div class="popularize-product-box ui-row mb-4"
                                     v-for="prod in moment.momentProducts">
                                    <!--<div class="pl-4 pb-2 small text-dark-gray text-title" v-if="prod.Description">{{prod.Description}}</div>-->
                                    <div class="ui-col ui-col-10"><img :src="prod.product.featuredPicture.downloadUrl" alt=""></div>
                                    <div class="ui-col ui-col-90 flex ui-nowrap" style="line-height: 3rem">
                                        <span class="x-small text-dark-gray">
                                            <span class="text">{{prod.product.Name}}</span>
                                        </span>
                                        <i class="icon iconfont icon-play_fill pl-4" style="vertical-align: middle"></i>
                                    </div>
                                </div>
                            </launch-app>

<!--转发 ！！！end-->
                            <div class="post-box mt-2 p-4 repost"
                                 style="background: #F7F9FE;"
                                 v-if="moment.rePost">

                                <!--推主名称和头像-->
                                <div class="moment-content overflow mb-4">
                                    <span class="text-blue fs-16 lh-22">@{{moment.rePost.owner.storeName}}</span>
                                    <span class="fs-16 lh-22"> : {{moment.rePost.content}}</span>
                                </div>

                                <!--图片-->
                                <div class="moment-picture-one mm-1" v-if="moment.rePost.pictures.length === 1">
                                    <img class="img-link"
                                         :style="{'max-height': clientWidth + 'px'}"
                                         :src="moment.rePost.pictures[0].mediaFileUrl"
                                         :data-img="moment.rePost.pictures[0].mediaFileUrl"
                                         @click="openPic(0)"
                                         v-if="!moment.rePost.pictures[0].mediaFileUrl">
                                    <img class="img-link"
                                         :style="{'max-height': clientWidth + 'px'}"
                                         :data-img="moment.rePost.pictures[0].mediaFileUrl"
                                         @click="openPic(0)"
                                         :src="moment.rePost.pictures[0].thumbnailUrl"
                                         v-if="moment.rePost.pictures[0].thumbnailUrl">
                                </div>
                                <div class="moment-pictures clearfix" v-if="moment.rePost.pictures.length > 1">
                                    <div class="moment-pic-box clearfix"
                                         :data-img="pic.mediaFileUrl"
                                         :style="{'height':moment.rePost.pictures.length === 1? picWidth66+'px': picWidth+'px','width': '33.33%'}"
                                         @click="openPic(index)"
                                         v-for="(pic,index) in moment.rePost.pictures">
                                        <img class="img-box" :src="pic.mediaFileUrl" v-if="!pic.thumbnailUrl">
                                        <img class="img-box" :src="pic.thumbnailUrl" v-if="pic.thumbnailUrl">
                                    </div>
                                </div>

                                <!--视频-->
                                <div v-if="moment.rePost.videos.length>0" class="mt-4">
                                    <video :src="moment.rePost.videos[0].mediaFileUrl"
                                           class="videoDisplay"
                                           controls="controls"
                                           preload="auto"
                                           muted
                                           style="width: 100%"></video>
                                </div>

                                <!--链接-->
                                <div class="link-box mb-3"
                                     @click="openLink(moment.rePost.externalPostUrl)"
                                     v-if="moment.rePost.externalPostUrl">
                                    <div class="link-icon"><i class="icon iconshare icon-lianjie"></i></div>
                                    <div class="link-text text-title">
                                        <span v-if="moment.rePost.externalPostText">{{moment.rePost.externalPostText}}</span>
                                        <span v-if="!moment.rePost.externalPostText && !moment.rePost.content">{{moment.rePost.externalPostUrl}}</span>
                                        <i class="icon iconfont icon-play_fill"></i>
                                    </div>
                                </div>

                                <!--产品-->
                                <launch-app type="post" :params="paramsForApp">
                                    <div class="popularize-product-box mb-4 flex"
                                         v-if="moment.rePost.momentProduct"
                                         v-clipboard="shareid">
                                        <img :src="moment.rePost.momentProduct.productImageUrl"
                                             class="img">
                                        <div class="flex-1 ui-nowrap" style="padding: 4px 0;">
                            <span class="x-small text-dark-gray">
                                <span class="text">{{moment.rePost.momentProduct.productName}}</span>
                            </span>
                                        </div>
                                    </div>
                                </launch-app>

                            </div>

<!--转发 ！！！end-->


                            <!--操作-->
                            <launch-app :type="type" :params="appParams">
                                <div class="operation pt-3 pb-3 ui-row ui-border-t mt-3 flex">
                                    <div class="flex-1 text-center">
                                        <i class="icon iconshare icon-dashang favorite-btn text-icon-gray"></i>
                                    </div>
                                    <div class="flex-1 text-center" :class="{active:moment.liked}">
                                        <i class="icon iconshare icon-dianzan like-btn text-icon-gray" :class="{active:moment.liked}"></i>
                                        <span class="small text-icon-gray" :class="{'color-pink':moment.liked}" v-if="moment.likedCount>0">{{moment.likedCount}}</span>
                                    </div>
                                    <div class="flex-1 text-center">
                                        <i class="icon iconshare icon-comment1 text-icon-gray"></i>
                                        <span class="small text-icon-gray" v-if="moment.commentCount>0">{{moment.commentCount}}</span>
                                    </div>
                                    <div class="flex-1 text-center">
                                        <i class="icon iconshare icon-share text-icon-gray"></i>
                                    </div>
                                </div>
                            </launch-app>
                        </div>
                    </li>
                </ul>
                <no-data v-if="list.length === 0"></no-data>
            </div>
        </div>
    </div>
</template>
<script>
    import LaunchApp from './LaunchApp.vue';
    import NoData from './NoData.vue';
    export default {
        props: {
            list: {
                type: Array,
                default: []
            },
            type: {
                type: String,
                default: 'space'
            },
            appParams: {
                type: String,
                default: ''
            }
        },
        components: {
            LaunchApp,
            NoData
        },
        filters: {
            formatTime:function (value) {
                return moment.utc(value).local().format('YYYY-MM-DD HH:mm');
            }
        },
        mounted() {

        },
        data() {
            return {
                fullWidth: document.body.clientWidth || document.documentElement.clientWidth,
                thirdFullWidth: (document.body.clientWidth - 20) / 3,
                message: {
                    en: {
                        "loadingMore": "点击加载更多"
                    },
                    zh: {
                        "loadingMore": "Click to load more"
                    }
                }
            }
        },
        methods: {
            openLink(link) {
                window.open(link);
            }
        }
    }
</script>
<style lang="less">
    .comp-moment-list {
        .moment-list {
            background-color: #fafafa;

            .overflow {
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }

            .moment-li {
                margin-bottom: 1rem;
            }
            .moment-item {
                padding: 1rem 1rem 0;
                position: relative;
                font-size: 1.4rem;

                .operation {
                    .iconshare {
                        margin-right: 2px;
                        font-size: 18px;
                        vertical-align: middle;
                    }
                    span {
                        vertical-align: middle;
                    }
                }


                .tycoon-avatar {
                    width: 40px;
                    height: 40px;
                    border-radius: 30px;
                }
                .moment-content {
                    margin: 4px 0;
                    line-height: 1.6;
                }
                .link-box {
                    overflow: hidden;
                    .link-icon {
                        float: left;
                        background: #e2e2e2;
                        width: 3.2rem;
                        height: 3.2rem;
                        text-align: center;
                        line-height: 3rem;
                        color: #4d4d4d;
                    }
                    .link-text {
                        float: left;
                        max-width: calc(100% - 3.2rem);
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        line-height: 3.2rem;
                        background-color: #F0F0F0;
                        padding: 0 1rem;
                        color: #696969;
                        font-size: 1.3rem;
                    }
                }
                .popularize-product-box img {
                    width: 30px;
                    height: 30px;
                    /* border-radius: .2rem; */
                    vertical-align: middle;
                    margin-right: .5rem;
                    background: #fff;
                }
            }
        }
    }
</style>
